import { type FC } from 'react'
import classNames from 'classnames'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { type BulkResultStatus } from './bulkInviteResult'
import { type BulkRowStatus } from './bulkSeatPreview'

export type BulkChipStatus = BulkRowStatus | BulkResultStatus

const _CHIPS: Record<BulkChipStatus, { icon: string; label: string; tooltip?: string }> = {
  ready: { icon: 'bi-check-circle-fill zocks-text-success', label: 'Ready' },
  seatNeeded: { icon: 'bi-x-circle-fill zocks-text-danger', label: 'Seat needed' },
  invalid: { icon: 'bi-x-circle-fill zocks-text-danger', label: 'Invalid' },
  invited: { icon: 'bi-check-circle-fill zocks-text-success', label: 'Invited' },
  alreadyMember: { icon: 'bi-check-circle-fill zocks-text-success', label: 'Invited', tooltip: 'Already a member (invitation sent)' },
  alreadyInvited: { icon: 'bi-dash-circle-fill zocks-text-gray-600', label: 'Already invited', tooltip: 'Invitation already exists, no new email was sent' },
  requested: { icon: 'bi-exclamation-circle-fill zocks-text-warning-text', label: 'Requested', tooltip: 'Seat was requested for this invite' },
  serverError: { icon: 'bi-x-circle-fill zocks-text-danger', label: 'Failed', tooltip: 'Server error, please try again' },
}

export interface BulkInviteRowStatusChipProps {
  status: BulkChipStatus
  errors?: string[]
}

export const BulkInviteRowStatusChip: FC<BulkInviteRowStatusChipProps> = ({ status, errors = [] }) => {
  const chip = (
    <span
      aria-label={errors.length > 0 ? `${_CHIPS[status].label}: ${errors.join(', ')}` : undefined}
      className='d-inline-flex align-items-center gap-1 paragraph-small zocks-text-gray-900 zocks-bg-color-white border zocks-border-color-gray-300 rounded-pill zocks-px-0.75 py-1 text-nowrap'
    >
      <i className={classNames('bi', _CHIPS[status].icon)} />
      {_CHIPS[status].label}
    </span>
  )

  const tooltip = errors.length > 0 ? errors.join(', ') : _CHIPS[status].tooltip
  if (!tooltip) {
    return chip
  }

  return (
    <Tooltip className='paragraph-small' title={tooltip} placement='top' offset={[0, 10]}>
      {chip}
    </Tooltip>
  )
}
